import React, { useCallback, useMemo, useState } from "react";
import Breadcrumbs from 'components/Common/Breadcrumb';
import MetaTags from 'react-meta-tags';
import Select from "react-select"
import {
  Container,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DateRangePicker, {
  DATE_RANGE_OPTIONS,
  createOption,
} from "components/Common/DateRangePicker"
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit"

import { AppConfiguration } from "config";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { SfDollarStringFormatter, capitalizeFirstLetter, capitalizeWord, checkUrlFiltersPresent, dollarFormatWithTwoDecimalPlaces, getIANATimezoneStringForAbbreviation, getLeadRedundStatus, getOptionFromValueForSelectBox, getParsedFilters, getPrimaryButtonClass, getPrimaryTextClass, printNameOrEmail, sortStringAsFloat, forColumnHeaderWrapper, getCurrentBrandFromLocalStorage, nullHandlerCustomizeColumns } from "helpers/sf_utils";
import { useEffect } from "react";
import { CALLS_FILTERED_COLUMNS_OBJECTS, CALLS_STATUS_OPTIONS, getLeadTypeById, LEADS_CALLS_STATUS_DEFAULT_VALUE, LEAD_TYPES, optionGroupTypeForCalls, PRODUCT_TYPE_IDS, REPORTING_TIMEZONE, REQUIRED_FEATURE_FLAGS, TABLE_COLMN_NAMES, STATUS_TYPES, convertStringifiedNullToNull, PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN, sortColumnsByOrder, TOOLTIPS, CALLS_BACKEND_SORTABLE_COLUMNS, DISPOSITION_EDITOR_CLASS, DISPOSITION_EDITOR_SELECTOR } from "helpers/sf_constants";
import UserStyle from "../Admin/Users/Users.module.css";
import { format, isAfter, isBefore } from "date-fns";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { getCalls, updateCall } from "store/calls/actions";
import { getCampaignOptions, timeFormatter } from "helpers/sf_dashboard_helper";
import { Link } from "react-router-dom";
import SfLoadingSkeleton from "components/Common/Loadings/SfLoadingSkeleton";
import { utcToZonedTime } from "date-fns-tz";
import _ from "lodash";
import useFeatureFlags from "hooks/useFeatureFlags";
import { getColumnDataFieldByMatchingPreference } from "helpers/user_column_preference_helper";
import CustomizeColumnsModal from "pages/Campaign/CommonComponents/CustomizeColumnsModals/CustomizeColumnsModal";
import { getCallStickyColumns, updateCallStickyColumns } from "store/user_column_preference/call-sticky-columns/actions";
import CallFilterModal from "./CallsFilterModal";
import { dateCreatedFormatter, defaultFormatter, yesNoFormatter } from "pages/Admin/Users/UserComponents/UserList/Formatters";
import ReactAudioPlayer from "react-audio-player";
import { useRef } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { bsh_getFilters, bsh_isAdminUserDetailsPresent, bsh_setFilters, STORAGE_KEY } from "helpers/sf_browser_storage_helper";
import { getCustomizeColumnsOrder } from "store/customize-columns-order/actions";
import { nameWithDeletedFormatter } from "helpers/sf_analytics_helper";
import ToggleableLink from "components/Common/ToggleableLink";
import useAccountCampaigns from "hooks/useAccountCampaigns";
import useUrlFilter from "hooks/useUrlFilter";
import { customSortCaret } from "helpers/bootstrap_table_helper";
import CustomExportCSVButton from "components/Common/CustomExportCSVButton";
import { exportCallsOnEmail } from "store/export-email/actions";
import ModifyLoadingIcon from "components/Common/Loadings/ModifyLoadingIcon";
import useNewBrandUI from "hooks/useNewBrandUI";
import useBrandList from "hooks/useBrandList";
import useSingleActionDispatcher from "hooks/useSingleActionDispatcher";
import { generateSICColumns } from "helpers/sf_leads_calls_helper";
import { isBenepathBrand } from "config";
import LeadNoteModal from "components/Common/Notes/LeadNoteModal";
import { createCallNotes, getCallNotesSuccess } from "store/notes/lead_notes/actions";
import { extractCallNotesFromCalls, openNotesModal, getNotesCountText as getNotesCountTextHelper } from "helpers/sf_lead_notes_helper";
import Skeleton from "react-loading-skeleton";
import OffsetPagination from "components/Common/OffsetPagination";

const { ExportCSVButton } = CSVExport
let dateFilter = null;

const CALLS_FILTERS = {
  FIRST_NAME: 'first_name',
  FIRST_NAME_VALUE: 'first_name_value',
  LAST_NAME: 'last_name',
  LAST_NAME_VALUE: 'last_name_value',
  PHONE_NUM: 'phone_num',
  PHONE_NUM_VALUE: 'phone_num_value',
  CALL_DURATION: 'call_duration',
  SELECTED_CALL_DURATION_VALUE: 'selected_call_duration_value',
  CALL_DURATION_VALUE: 'call_duration_value',
  STATE: 'state',
  STATE_VALUE: 'state_value',
  RECEIVED: 'received',
  RECEIVED_VALUE: 'received_value',
  RECEIVED_VALUE_LABEL: 'received_value_label',
  ADDRESS: 'address',
  ADDRESS_VALUE: 'address_value',
  CITY: 'city',
  CITY_VALUE: 'city_value',
  ZIP_CODE: 'zip_code',
  ZIP_CODE_VALUE: 'zip_code_value',
  DRIVERS: 'drivers',
  SELECTED_DRIVERS_VALUE: 'selected_drivers_value',
  DRIVERS_VALUE: 'drivers_value',
  VEHICLES: 'vehicles',
  SELECTED_VEHICLES_VALUE: 'selected_vehicles_value',
  VEHICLES_VALUE: 'vehicles_value',
  INSURED: 'insured',
  INSURED_VALUE: 'insured_value',
  LEAD_TYPE: 'lead_type',
  LEAD_TYPE_VALUE: 'lead_type_value',
  STATUS: 'status',
  STATUS_VALUE: 'status_value',
  DISPOSITION: 'disposition',
  DISPOSITION_VALUE: 'disposition_value',
  CAMPAIGN_NAME: 'campaign_name',
  CAMPAIGN_NAME_VALUE: 'campaign_name_value',
  BILLABLE: 'billable',
  BILLABLE_VALUE: 'billable_value',
  BRAND_NAME: 'brand_name',
  BRAND_NAME_VALUE: 'brand_name_value',

}

const DEFAULT_SORT_COLUMN = 'created_at';
const DEFAULT_SORT_DIRECTION = 'desc';

export const costFormatter = (cellContent, row) => {
  if (cellContent) {
    return dollarFormatWithTwoDecimalPlaces(cellContent);
  } else {
    return (<div className="d-flex align-items-center">
      <i id={`base-bid-${row.id}`} className={`bx bx-info-circle ${getPrimaryTextClass()} bx-xs`}></i> --
      {row?.reason_for_not_charging && (<UncontrolledTooltip
        placement="top"
        target={`base-bid-${row.id}`}
      >
        {row?.reason_for_not_charging || ""}
      </UncontrolledTooltip>)}
    </div>)
  }
}

const Calls = () => {
  const currentPlayerRef = useRef(null);

  //For Audio player
  const [currentPlayer, setCurrentPlayer] = useState(null);

  const handleAudioPlayerClick = (e, call) => {
    if (currentPlayerRef.current !== e.target) {

      if (currentPlayerRef.current) {
        currentPlayerRef.current.pause();
      }
      currentPlayerRef.current = e.target;
    }
  };

  const dispatch = useDispatch();
  const getNewUrl = useUrlFilter();
  const history = useHistory();
  const urlQueryParams = window.location.href;
  const show_rtb_brand_ui_changes = useNewBrandUI();

  const [isFeatureFlagActive] = useFeatureFlags();
  const {
    error,
    loading,
    callsData,
    current_account,
    current_brand,
    user_column_preference_call,
    user_column_preference_call_loading,
    last_page_fetched,
    total_number_of_pages,
    has_next_page,
    has_lookahead_pages,
    calls_customize_columns_order,
    export_email_loading,
    call_notes,
    call_notes_loading
  } = useSelector(state => ({
    error: state.Calls.error,
    loading: state.Calls.loading,
    callsData: state.Calls.calls,
    current_brand: state.Brands.current_brand,
    current_account: state.accounts.current_account,
    user_column_preference_call: state.UserCallColumnPreference.user_column_preference_call,
    user_column_preference_call_loading: state.UserCallColumnPreference.loading,
    last_page_fetched: state.Calls.last_page_fetched,
    total_number_of_pages: state.Calls.total_number_of_pages,
    has_next_page: state.Calls.has_next_page,
    has_lookahead_pages: state.Calls.has_lookahead_pages,
    calls_customize_columns_order: state.CustomizeColumnsOrder.calls_customize_columns_order,
    export_email_loading: state.ExportEmail.call_loading,
    call_notes: state.leadNotesReducer.call_notes,
    call_notes_loading: state.leadNotesReducer.call_notes_loading,
  }));

  const [unscoped_account_campaigns, _account_campaigns, hasActiveCommercialCampaign] = useAccountCampaigns();

  const showSICColumns = useMemo(() => {
    return isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_SIC_CODE_TARGETING)
  }, [isFeatureFlagActive])

  const showLeadAndCallsNotes = useMemo(() => {
    return isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_LEAD_AND_CALLS_NOTES)
  }, [isFeatureFlagActive])
  const shouldUseOffsetPagination = useMemo(() => (
    isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_OFFSET_PAGINATION_APPLICATION)
  ), [isFeatureFlagActive])

  const backendSortingEnabled = useMemo(
    () => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_BACKEND_COLUMN_SORTING),
    [isFeatureFlagActive],
  );
  const [sortState, setSortState] = useState({ column: DEFAULT_SORT_COLUMN, direction: DEFAULT_SORT_DIRECTION });

  const handleTableChange = useCallback((type, { sortField, sortOrder }) => {
    if (type !== 'sort' || !backendSortingEnabled) return;
    if (sortField === sortState.column && sortOrder === sortState.direction) return;
    setSortState({ column: sortField, direction: sortOrder });
  }, [backendSortingEnabled, sortState]);

  const [selectedDateRange, setSelectedDateRange] = useState(createOption(
    DATE_RANGE_OPTIONS.ALL_TIME,
    new Date(),
    getIANATimezoneStringForAbbreviation(current_account?.timezone) || REPORTING_TIMEZONE)
  );
  const dropdownPressTargetRef = useRef(null);
  const [selectedLeadGroup, setSelectedLeadGroup] = useState(optionGroupTypeForCalls[0].options[0]);
  const [filteredCalls, setfilteredCalls] = useState([]);
  const [loadingRowIndex, setLoadingRowIndex] = useState(null);
  const [loadingCell, setLoadingCell] = useState({ row: null, col: null });
  const [nameInput, setNameInput] = useState('');
  const [isEditingStatus, setIsEditingStatus] = useState({});
  const [editIconRow, setEditIconRow] = useState(); // State variable to show/hide
  const [selectedStatus, setSelectedStatus] = useState(getOptionFromValueForSelectBox(CALLS_STATUS_OPTIONS, LEADS_CALLS_STATUS_DEFAULT_VALUE.RECEIVED_NOT_WORKED_YET));

  const [isActiveFilterModal, setIsActiveFilterModal] = useState(false);
  const [customizeColumnsModal, setCustomizeColumnsModal] = useState({
    isActiveModal: false,
    columns: [],
  })
  const [searchTerm, setSearchTerm] = useState('');
  const [filterModal, setFilterModal] = useState({

    first_name: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.FIRST_NAME) || false,
    first_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.FIRST_NAME_VALUE) || "",

    last_name: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LAST_NAME) || false,
    last_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LAST_NAME_VALUE) || "",

    call_duration: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CALL_DURATION) || false,
    selected_call_duration_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.SELECTED_CALL_DURATION_VALUE) || "",
    call_duration_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CALL_DURATION_VALUE) || "",

    phone_num: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.PHONE_NUM) || false,
    phone_num_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.PHONE_NUM_VALUE) || "",

    state: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATE) || false,
    state_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATE_VALUE) || null,

    received: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.RECEIVED) || false,
    received_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.RECEIVED_VALUE) || "",
    received_value_label: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.RECEIVED_VALUE_LABEL) || "",

    address: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ADDRESS) || false,
    address_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ADDRESS_VALUE) || "",

    city: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CITY) || false,
    city_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CITY_VALUE) || "",

    zip_code: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ZIP_CODE) || false,
    zip_code_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ZIP_CODE_VALUE) || "",

    drivers: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DRIVERS) || false,
    selected_drivers_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.SELECTED_DRIVERS_VALUE) || "",
    drivers_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DRIVERS_VALUE) || "",

    vehicles: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.VEHICLES) || false,
    selected_vehicles_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.SELECTED_VEHICLES_VALUE) || "",
    vehicles_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.VEHICLES_VALUE) || "",

    insured: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.INSURED) || false,
    insured_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.INSURED_VALUE) || "",

    lead_type: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LEAD_TYPE) || false,
    lead_type_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LEAD_TYPE_VALUE) || "",

    status: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATUS) || false,
    status_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATUS_VALUE) || null,

    disposition: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DISPOSITION) || false,
    disposition_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DISPOSITION_VALUE) || null,

    campaign_name: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CAMPAIGN_NAME) || false,
    campaign_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CAMPAIGN_NAME_VALUE) || "",

    billable: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BILLABLE) || false,
    billable_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BILLABLE_VALUE) || "",

    brand_name: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BRAND_NAME) || false,
    brand_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BRAND_NAME_VALUE) || "",
  });
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [activeFilteredColumnsState, setActiveFilteredColumnsState] = useState(null)
  const [customizeColumnsOrder, setCustomizeColumnsOrder] = useState({})
  const [callNoteModal, setCallNoteModal] = useState({
    action: false,
    lead_id: null,
    call_id: null,
    notes: [],
  });

  const updatedBrandId = () => {
    let brand_id = show_rtb_brand_ui_changes ? null : current_brand?.id || getCurrentBrandFromLocalStorage()?.id;
    return brand_id
  }

  const buildCallsListQueryParams = (pageNumber = 1, filterModal = null) => {
    const dateRangeValue = _.cloneDeep(selectedDateRange.value);
    const params = {
      page_number: pageNumber,
      brand_id: updatedBrandId(),
    };
    if (dateRangeValue?.startDate) {
      params.start_date = dateRangeValue.startDate.toISOString();
    }
    if (dateRangeValue?.endDate) {
      params.end_date = dateRangeValue.endDate.toISOString();
    }
    if (filterModal) {
      const filterModalData = convertStringifiedNullToNull(filterModal);
      params.filters = JSON.stringify(filterModalData || {});
    }
    if (backendSortingEnabled) {
      params.sort_column = CALLS_BACKEND_SORTABLE_COLUMNS.includes(sortState.column)
        ? sortState.column : DEFAULT_SORT_COLUMN;
      params.sort_direction = sortState.direction || DEFAULT_SORT_DIRECTION;
    }
    return params;
  };

  const fetchCallsPage = (pageNumber = 1, filterModal = null) => {
    const queryParams = buildCallsListQueryParams(pageNumber, filterModal);
    const newUrl = getNewUrl(queryParams, REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_URL_FILTERS_ON_CALLS)
    if (newUrl != '') {
      history.push(newUrl);
    }
    !loading && dispatch(getCalls({
      queryParams: queryParams,
      replaceResults: shouldUseOffsetPagination,
      useCache: shouldUseOffsetPagination,
    }, true));
  }

  const getCallsExportFilters = () => {
    if (filterCheckedCount <= 0) {
      return null;
    }

    return Object.keys(activeFilteredColumnsState || {}).length > 0
      ? activeFilteredColumnsState
      : filterModal;
  }

  useEffect(() => {
    const mapped_calls_data = callsData.map((call) => ({ ...call, drivers: call.lead_applicants?.length, vehicles: call?.lead_vehicles?.length }))
    setfilteredCalls(mapped_calls_data)
    // Extract call notes from calls data and dispatch to store
    if (isBenepathBrand && callsData && callsData.length > 0) {
      const extractedNotes = extractCallNotesFromCalls(callsData);
      if (extractedNotes.notes.length > 0 || extractedNotes.processedCallIds.length > 0) {
        dispatch(getCallNotesSuccess(extractedNotes));
      }
    }
  }, [callsData, dispatch]);

  const campaignOptions = useMemo(() => {
    const campaigns = unscoped_account_campaigns?.filter(campaign => campaign.product_type_id === PRODUCT_TYPE_IDS.CALLS)

    const campaignOpts = getCampaignOptions(campaigns, show_rtb_brand_ui_changes)
    return campaignOpts;
  }, [unscoped_account_campaigns, show_rtb_brand_ui_changes]);

  const { brandList } = useBrandList(true)

  useEffect(() => {
    isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CALLS_PAGE) &&
      dispatch(getCustomizeColumnsOrder({ page_name: PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CALLS }));
  }, []);

  useSingleActionDispatcher(getCallStickyColumns());

  useEffect(() => {
    selectedDateRange && dateFilter && dateFilter(selectedDateRange.value);
  }, [selectedDateRange]);
  useEffect(() => {
    if (searchTerm) {
      const fltrdCalls = callsData.filter((call) => {
        return call.lead_detail.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          call.lead_detail.last_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          call.lead_detail.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          call.lead_detail.phone.toLowerCase().includes(searchTerm.toLowerCase()) ||
          call.lead_detail.state.toLowerCase().includes(searchTerm.toLowerCase())
      })
      setfilteredCalls(fltrdCalls)
    } else {
      setfilteredCalls(callsData)
    }
  }, [searchTerm]);

  // For Name Formatter
  function nameFormatter(cellContent, row) {
    const name = printNameOrEmail(row?.lead_detail?.first_name, row?.lead_detail?.last_name, null, '-- --');
    const detailsPath = row?.lead_id
      ? `/calls/${row?.lead_id}`
      : (row?.release_data ? `/calls/parsed/${row?.id}` : null);

    if (!row?.charged && !row?.release_data) {
      return <div>{name}</div>;
    }

    if (detailsPath) {
      return (
        <Link to={{ pathname: detailsPath }} className='text-sfblue'>
          {name}
        </Link>
      );
    }

    return <div>{name}</div>;
  }

  function detailsFormatter(cellContent, row) {
    if (row?.lead_id || row?.release_data) {
      const link = row?.lead_id ? `/calls/${row?.lead_id}` : `/calls/parsed/${row?.id}`;
      return (
        <Link to={link} className="text-sfblue">
          View
        </Link>
      );
    }
    return <span>{'--'}</span>;
  }

  const onFilterByDateFunc = (filterVal, data) => {
    if (!!filterVal == false) {
      return data;
    }

    return data.filter((calls_date) => {
      const date = new Date(calls_date);
      try {
        if (filterVal.startDate && isBefore(date, filterVal.startDate)) {
          return false;
        }

        if (filterVal.endDate && isAfter(date, filterVal.endDate)) {
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    });
  };

  const [queryParamsState, setQueryParamsState] = useState({});

  const handleLeadType = (selectOpt) => {
    const queryParams = { ...queryParamsState };
    queryParams.is_custom_filter = true
    queryParams.lead_type_id = LEAD_TYPES.find(lt => lt.name === selectOpt.value)?.id || ''
    setQueryParamsState({ ...queryParams })
    dispatch(getCalls({ queryParams }, queryParams.is_custom_filter))
    setSelectedLeadGroup(selectOpt);
  }

  useEffect(() => {
    if (calls_customize_columns_order) {
      const columns_to_include = [
        "call_name",
        "call_phone",
        "call_insured",
        "call_city",
        "call_state",
        "call_num_employees",
        "call_address",
        "call_zip_code",
        "brand",
        "call_campaign_name",
        "call_status",
        "call_received",
        "call_vehicles",
        "status",
        "call_duration",
        "cost",
        "call_refund_status",
        "profile",
        "call_lead_type",
        "transfer_type",
        "call_recording",
        "call_drivers",
        "aid",
        "cid",
        "call_sic4",
        "call_naics",
        "call_business_desc",
        "call_business_name",
        ...(isBenepathBrand ? ["call_notes"] : [])
      ];

      const filteredCustomizeColumns = {};
      Object.keys(calls_customize_columns_order).forEach(key => {
        if (columns_to_include.includes(key)) {
          filteredCustomizeColumns[key] = calls_customize_columns_order[key];
        }
      });

      setCustomizeColumnsOrder(filteredCustomizeColumns);
    }
  }, [calls_customize_columns_order]);

  const handleTimeAndDate = (selectOpt) => {
    const queryParams = { ...queryParamsState };
    queryParams.is_custom_filter = true
    const dateRangeValue = _.cloneDeep(selectOpt.value);
    if (dateRangeValue?.startDate) {
      queryParams.start_date = dateRangeValue.startDate.toISOString();
    }
    if (dateRangeValue?.endDate) {
      queryParams.end_date = dateRangeValue.endDate.toISOString();
    }
    setQueryParamsState({ ...queryParams })
    !loading && dispatch(getCalls({ queryParams }, queryParams.is_custom_filter))
    setSelectedDateRange(selectOpt);
  }

  const onClickSaveDisposition = (row, _nameInput) => {
    dispatch(updateCall({ id: row?.lead_id, disposition: selectedStatus?.value }))
    setIsEditingStatus(null)
  }

  // Get notes count text for a call row
  const getNotesCountText = (row) => {
    return getNotesCountTextHelper({ call_notes, row });
  }

  // Notes formatter for Calls page (Benepath only)
  const notesFormatter = (cell, row, rowIndex, call_notes_loading) => {
    return (
      <div className="d-flex align-items-center">
        {(call_notes_loading ? <Skeleton width={60} height={20} /> :
          <a onClick={() => onClickOpenNotes(row)} className='text-sfblue'>
            {getNotesCountText(row)}
          </a>)}
      </div>
    );
  }

  const onClickOpenNotes = (call) => {
    if (!isBenepathBrand) return;
    const lead_id = call?.lead_id;
    // Use quote_call.id if available (for call detail structure), otherwise use call.id
    const call_id = call?.quote_call?.id || call?.id;
    if (call_id) {
      openNotesModal(null, lead_id, setCallNoteModal, call_id, call_notes);
    }
  }

  const onSubmitCallNoteModal = (newNote) => {
    if (!isBenepathBrand) return;
    const call_id = callNoteModal?.call_id;
    if (!call_id) return;
    dispatch(createCallNotes({
      call_id: call_id,
      call_note: {
        text: newNote.text
      }
    }));
  }

  const onCloseCallNoteModal = () => {
    setCallNoteModal({
      action: false,
      lead_id: null,
      call_id: null,
      notes: [],
    });
  }

  // For phone number Formatter
  function phoneNumberFormatter(cellContent, row) {
    return (
      <span>{(cellContent && cellContent !== '') ? cellContent.replace(/([\dX]{3})([\dX]{3})([\dX]{4})/, '$1-$2-$3') : "--"}</span>
    )
  }

  // ----------------- Filters Start ---------------------

  //For Filter OnSubmit
  const onSubmitOpenFilterModal = (values) => {
    setFilterModal({ ...filterModal, ...values })
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.FIRST_NAME, values.first_name_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.FIRST_NAME_VALUE, values.first_name_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LAST_NAME, values.last_name)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LAST_NAME_VALUE, values.last_name_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.PHONE_NUM, values.phone_num)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.PHONE_NUM_VALUE, values.phone_num_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CALL_DURATION, values.call_duration)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.SELECTED_CALL_DURATION_VALUE, values.selected_call_duration_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CALL_DURATION_VALUE, values.call_duration_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATE, values.state)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATE_VALUE, values.state_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.RECEIVED, values.received)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.RECEIVED_VALUE, values.received_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.RECEIVED_VALUE_LABEL, values.received_value_label)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ADDRESS, values.address)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ADDRESS_VALUE, values.address_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CITY, values.city)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CITY_VALUE, values.city_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ZIP_CODE, values.zip_code)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.ZIP_CODE_VALUE, values.zip_code_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DRIVERS, values.drivers)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.SELECTED_DRIVERS_VALUE, values.selected_drivers_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DRIVERS_VALUE, values.drivers_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.VEHICLES, values.vehicles)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.SELECTED_VEHICLES_VALUE, values.selected_vehicles_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.VEHICLES_VALUE, values.vehicles_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.INSURED, values.insured)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.INSURED_VALUE, values.insured_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LEAD_TYPE, values.lead_type)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.LEAD_TYPE_VALUE, values.lead_type_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATUS, values.status)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.STATUS_VALUE, values.status_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DISPOSITION, values.disposition)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.DISPOSITION_VALUE, values.disposition_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CAMPAIGN_NAME, values.campaign_name)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.CAMPAIGN_NAME_VALUE, values.campaign_name_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BILLABLE, values.billable)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BILLABLE_VALUE, values.billable_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BRAND_NAME, values.brand_name)
    bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, CALLS_FILTERS.BRAND_NAME_VALUE, values.brand_name_value)
    setIsActiveFilterModal(false);
  }

  //For Filter Modal Open 
  const onClickOpenFilterModal = () => {
    setIsActiveFilterModal(true)
  }
  //For Filter Modal Close 
  const onCloseFilterModal = () => {
    setIsActiveFilterModal(false);
  }

  const onClickRemoveFilter = (fieldName) => {
    if (['call_duration', 'drivers', 'vehicles',].includes(fieldName)) {
      setFilterModal({ ...filterModal, [fieldName]: !fieldName, [fieldName + '_value']: "", ['selected_' + fieldName + '_value']: "" })
      bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, fieldName, !fieldName)
      bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, fieldName + '_value', "")
      bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, 'selected_' + fieldName + '_value', "")
    } else {
      setFilterModal({ ...filterModal, [fieldName]: !fieldName, [fieldName + '_value']: "" })
      bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, fieldName, !fieldName)
      bsh_setFilters(STORAGE_KEY.FILTERS.CALLS, fieldName + '_value', "")
    }
    setFilteredColumns([])
  }

  const filterCount = useMemo(() => {
    return filteredColumns?.length
  }, [filteredColumns])

  const filterCheckedCount = useMemo(() => {
    let count = 0
    for (const k in filterModal) {
      if (filterModal[k] === true && k !== 'isActiveModal') {
        count += 1
      }
    }
    return count
  }, [filterModal])

  useEffect(() => {
    let isUpdateStates = false;
    let isFilteredColumns = [];
    const activeFilteredColumns = {}

    if (filterModal?.first_name && filterModal?.first_name_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.FIRST_NAME, value: filterModal?.first_name_value })
      activeFilteredColumns.first_name = filterModal?.first_name;
      activeFilteredColumns.first_name_value = filterModal?.first_name_value;
    }

    if (filterModal?.last_name && filterModal?.last_name_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.LAST_NAME, value: filterModal?.last_name_value })
      activeFilteredColumns.last_name = filterModal?.last_name;
      activeFilteredColumns.last_name_value = filterModal?.last_name_value;
    }

    if (filterModal?.phone_num && filterModal?.phone_num_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.PHONE, value: filterModal?.phone_num_value })
      activeFilteredColumns.phone_num = filterModal?.phone_num;
      activeFilteredColumns.phone_num_value = filterModal?.phone_num_value;
    }

    if (filterModal?.call_duration && filterModal?.call_duration_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.CALL_DURATION, value: filterModal?.selected_call_duration_value + " " + timeFormatter(filterModal?.call_duration_value) })
      activeFilteredColumns.call_duration = filterModal?.call_duration;
      activeFilteredColumns.call_duration_value = filterModal?.call_duration_value;
      activeFilteredColumns.selected_call_duration_value = filterModal?.selected_call_duration_value;
    }

    if (filterModal?.campaign_name && JSON.parse(filterModal?.campaign_name_value)) {
      isUpdateStates = true;
      const campaign_array = JSON.parse(filterModal?.campaign_name_value)
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.CAMPAIGN_NAME, value: campaign_array.map(el => el.label).join(', ') })
      activeFilteredColumns.campaign_name = filterModal?.campaign_name;
      activeFilteredColumns.campaign_name_value = filterModal?.campaign_name_value;
    }

    if (filterModal?.brand_name && JSON.parse(filterModal?.brand_name_value)) {
      isUpdateStates = true;
      const brand_array = JSON.parse(filterModal?.brand_name_value)
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.BRAND_NAME, value: brand_array.map(el => el.label).join(', ') })
      activeFilteredColumns.brand_name = filterModal?.brand_name;
      activeFilteredColumns.brand_name_value = filterModal?.brand_name_value;
    }

    if (filterModal?.received && JSON.parse(filterModal?.received)) {
      isUpdateStates = true;
      if (JSON.parse(filterModal?.received_value)?.startDate == null
        && JSON.parse(filterModal?.received_value)?.endDate == null) {
        isFilteredColumns.push({
          ...CALLS_FILTERED_COLUMNS_OBJECTS.RECEIVED,
          value: 'All time'
        })

      } else {
        isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.RECEIVED, value: format(utcToZonedTime(JSON.parse(filterModal?.received_value)?.startDate, REPORTING_TIMEZONE), 'MM/d/yyyy') + " - " + format(utcToZonedTime(JSON.parse(filterModal?.received_value)?.endDate, REPORTING_TIMEZONE), 'MM/d/yyyy') })
      }
      activeFilteredColumns.received = filterModal?.received;
      activeFilteredColumns.received_value = filterModal?.received_value;
      activeFilteredColumns.received_value_label = filterModal?.received_value_label;
    }

    if (filterModal?.insured && JSON.parse(filterModal?.insured_value)?.label) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.INSURED, value: JSON.parse(filterModal?.insured_value)?.label })
      activeFilteredColumns.insured = filterModal?.insured;
      activeFilteredColumns.insured_value = filterModal?.insured_value;
    }

    if (filterModal?.billable && JSON.parse(filterModal?.billable_value)?.label) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.BILLABLE, value: JSON.parse(filterModal?.billable_value)?.label })
      activeFilteredColumns.billable = filterModal?.billable;
      activeFilteredColumns.billable_value = filterModal?.billable_value;
    }

    if (filterModal?.address && filterModal?.address_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.ADDRESS, value: filterModal?.address_value })
      activeFilteredColumns.address = filterModal?.address;
      activeFilteredColumns.address_value = filterModal?.address_value;
    }

    if (filterModal?.city && filterModal?.city_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.CITY, value: filterModal?.city_value })
      activeFilteredColumns.city = filterModal?.city;
      activeFilteredColumns.city_value = filterModal?.city_value;
    }

    if (filterModal?.state && JSON.parse(filterModal?.state_value)) {
      isUpdateStates = true;
      const state_array = JSON.parse(filterModal?.state_value)
      state_array.length !== 0 && isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.STATE, value: state_array.map(el => el.value).join(', ') })
      activeFilteredColumns.state = filterModal?.state;
      activeFilteredColumns.state_value = filterModal?.state_value;
    }

    if (filterModal?.zip_code && filterModal?.zip_code_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.ZIP_CODE, value: filterModal?.zip_code_value })
      activeFilteredColumns.zip_code = filterModal?.zip_code;
      activeFilteredColumns.zip_code_value = filterModal?.zip_code_value;
    }

    if (filterModal?.lead_type && JSON.parse(filterModal?.lead_type_value)) {
      isUpdateStates = true;
      const lead_type_array = JSON.parse(filterModal?.lead_type_value)
      lead_type_array.length !== 0 && isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.LEAD_TYPE, value: lead_type_array.map(el => el.label).join(', ') })
      activeFilteredColumns.lead_type = filterModal?.lead_type;
      activeFilteredColumns.lead_type_value = filterModal?.lead_type_value;
    }

    if (filterModal?.drivers && filterModal?.drivers_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.DRIVERS, value: filterModal?.selected_drivers_value + " " + (filterModal?.drivers_value) })
      activeFilteredColumns.drivers = filterModal?.drivers;
      activeFilteredColumns.drivers_value = filterModal?.drivers_value;
      activeFilteredColumns.selected_drivers_value = filterModal?.selected_drivers_value;
    }

    if (filterModal?.vehicles && filterModal?.vehicles_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.VEHICLES, value: filterModal?.selected_vehicles_value + " " + (filterModal?.vehicles_value) })
      activeFilteredColumns.vehicles = filterModal?.vehicles;
      activeFilteredColumns.vehicles_value = filterModal?.vehicles_value;
      activeFilteredColumns.selected_vehicles_value = filterModal?.selected_vehicles_value;
    }

    if (filterModal?.status && JSON.parse(filterModal?.status_value)) {
      isUpdateStates = true;
      const status_array = JSON.parse(filterModal?.status_value)
      status_array.length !== 0 && isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.STATUS, value: status_array.map(el => el.label).join(', ') })
      activeFilteredColumns.status = filterModal?.status;
      activeFilteredColumns.status_value = filterModal?.status_value;
    }

    if (filterModal?.disposition && JSON.parse(filterModal?.disposition_value)) {
      isUpdateStates = true;
      const disposition_array = JSON.parse(filterModal?.disposition_value)
      disposition_array.length !== 0 && isFilteredColumns.push({ ...CALLS_FILTERED_COLUMNS_OBJECTS.DISPOSITION, value: disposition_array.map(el => el.value).join(', ') })
      activeFilteredColumns.disposition = filterModal?.disposition;
      activeFilteredColumns.disposition_value = filterModal?.disposition_value;
    }

    setActiveFilteredColumnsState(activeFilteredColumns);
    if (isUpdateStates) {
      fetchCallsPage(1, activeFilteredColumns)
      setFilteredColumns(isFilteredColumns);
      return
    }
    fetchCallsPage()
    setFilteredColumns([]);
  }, [filterModal, current_brand, show_rtb_brand_ui_changes, sortState])

  // ----------------- Filters End ---------------------

  // ----------------- Customize Columns Start ---------------------

  //For CustomizeColumns Modal Close
  const onClickOpenCustomizeColumnsModal = () => {
    let userColumnPreferenceFields = [];
    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE)) {
      userColumnPreferenceFields = getColumnDataFieldByMatchingPreference(callsColumn, hide_user_column_preference, 'columnName');
    }

    let sortedCustomizeColumns;
    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CALLS_PAGE)) {
      sortedCustomizeColumns = userColumnPreferenceFields;
    }
    else {
      sortedCustomizeColumns = sortColumnsByOrder(userColumnPreferenceFields, customizeColumnsOrder);
    }
    setCustomizeColumnsModal({
      ...customizeColumnsModal,
      isActiveModal: true,
      columns: sortedCustomizeColumns,
    })
  }

  //For CustomizeColumns Modal Close
  const onCloseCustomizeColumnsModal = () => {
    setCustomizeColumnsModal({
      ...customizeColumnsModal,
      isActiveModal: false,
      columns: [],
    })
  }

  //For CustomizeColumns OnSubmit
  const onSubmitCustomizeColumnsModal = values => {
    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE)) {
      const userColumnPreference = getColumnDataFieldByMatchingPreference(values, hide_user_column_preference, 'columnName');
      const userColumnPreferenceData = userColumnPreference.reduce((a, c) => Object.assign(a, { [c.columnName]: c.hidden }), {});
      const userColumnPreferenceFinalData = {
        user_column_preference_call: { ...userColumnPreferenceData, id: user_column_preference_call?.id }
      }
      dispatch(updateCallStickyColumns(userColumnPreferenceFinalData));
    }
    onCloseCustomizeColumnsModal()
  }

  const handleColumns = singe_obj => {
    setCustomizeColumnsModal(preState => {
      const tempPrevState = preState?.columns.map(prev =>
        prev.text === singe_obj.text && prev.dataField === singe_obj.dataField
          ? { ...singe_obj, hidden: !singe_obj.hidden }
          : prev
      )
      return { ...preState, columns: tempPrevState }
    })
  }

  let _hide_user_column_preference = _.cloneDeep(user_column_preference_call)
  for (const key in user_column_preference_call) {
    _hide_user_column_preference[key] = user_column_preference_call == null ? false : user_column_preference_call[key]
  }

  const hide_user_column_preference = useMemo(() => {
    const updated_hide_col = { ..._hide_user_column_preference }
    if (current_account) {
      if (!(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE))) {
        updated_hide_col['call_name'] = false;
        updated_hide_col['call_phone'] = false;
        updated_hide_col['call_duration'] = false;
        updated_hide_col['call_state'] = false;
        updated_hide_col['call_received'] = false;
        updated_hide_col['call_recording'] = false;
        updated_hide_col['call_insured'] = false;
        updated_hide_col['call_address'] = false;
        updated_hide_col['call_zip_code'] = false;
        updated_hide_col['call_city'] = false;
        updated_hide_col['call_vehicles'] = false;
        updated_hide_col['call_drivers'] = false;
        updated_hide_col['call_lead_type'] = false;
        updated_hide_col['call_campaign_name'] = false;
        updated_hide_col['call_status'] = false;
        updated_hide_col['aid'] = false;
        updated_hide_col['cid'] = false;
      }

      if (!(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_STATUS_COLUMN_IN_LEADS_AND_CALLS))) {
        updated_hide_col['call_status'] = null;
      }
      if (!(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_STATUS_IN_CALLS))) {
        updated_hide_col['status'] = null;
      }
      if (current_account?.enterprise) {
        updated_hide_col['call_refund_status'] = null;
      }
      if (!show_rtb_brand_ui_changes) {
        updated_hide_col['brand'] = null;
      }
      if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_GROUP_HEALTH_LEAD_TYPE)) {
        updated_hide_col['call_num_employees'] = null;
      }

      if (!showSICColumns) {
        updated_hide_col['call_sic4'] = null;
        updated_hide_col['call_naics'] = null;
        updated_hide_col['call_business_desc'] = null;
        updated_hide_col['call_business_name'] = null;
      } else if (!hasActiveCommercialCampaign) {
        updated_hide_col['call_sic4'] = null;
        updated_hide_col['call_naics'] = null;
        updated_hide_col['call_business_desc'] = null;
      }

      // Hide call_notes column if not Benepath brand
      if (!isBenepathBrand) {
        updated_hide_col['call_notes'] = null;
      }

    }
    return updated_hide_col;

  }, [current_account, _hide_user_column_preference, user_column_preference_call])

  // ----------------- Customize Columns End ---------------------
  const backendSortableSet = backendSortingEnabled ? new Set(CALLS_BACKEND_SORTABLE_COLUMNS) : null;
  const colSort = (dataField, clientSort) => backendSortableSet ? backendSortableSet.has(dataField) : clientSort;

  const callsColumn = [
    {
      dataField: 'status',
      text: 'Call Status',
      headerFormatter: forColumnHeaderWrapper,
      hidden: (hide_user_column_preference?.['status'] === null) ? true : (hide_user_column_preference?.['status']),
      sort: colSort('status', true),
      columnName: 'status',
      formatter: (cellContent, row) => {
        switch (cellContent) {
          case STATUS_TYPES.PENDING:
            return <span><i className='mdi mdi-circle font-size-16 sfyellow' /> In Progress</span>
          case STATUS_TYPES.COMPLETED:
            return <span><i className='mdi mdi-circle font-size-16 sfgreen' /> Completed</span>
          case STATUS_TYPES.FAILED:
            return <span><i className='mdi mdi-circle font-size-16 sfred' /> Failed</span>
          case STATUS_TYPES.NO_ANSWER:
            return <span><i className='mdi mdi-circle font-size-16 sfred' /> No Answer</span>
          case STATUS_TYPES.BUSY:
            return <span><i className='mdi mdi-circle font-size-16 sfred' /> Busy</span>
          default:
            return <span><i className='mdi mdi-circle font-size-16 sfyellow' /> In Progress</span>
        }
      },
      csvFormatter: (cellContent, row) => {
        switch (cellContent) {
          case STATUS_TYPES.PENDING:
            return 'In Progress'
          case STATUS_TYPES.COMPLETED:
            return 'Completed'
          case STATUS_TYPES.FAILED:
            return 'Failed'
          case STATUS_TYPES.NO_ANSWER:
            return 'No Answer'
          case STATUS_TYPES.BUSY:
            return 'Busy'
          default:
            return 'In Progress'
        }
      }
    },
    {
      dataField: 'name',
      text: 'Name',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('name', true),
      formatter: nameFormatter,
      hidden: (hide_user_column_preference?.['call_name'] === null) ? true : (hide_user_column_preference?.['call_name']),
      sortFunc: (_a, _b, order, _dataField, rowA, rowB) => { //Sorting first name and last name
        const nameA = rowA?.lead_detail?.first_name;
        const nameB = rowB?.lead_detail?.first_name;
        const lastNameA = rowA?.lead_detail?.last_name;
        const lastNameB = rowB?.lead_detail?.last_name;

        if (order === 'asc') {
          if (nameA === nameB) {
            return lastNameA?.localeCompare(lastNameB);
          }
          return nameA?.localeCompare(nameB);
        } else {
          if (nameA === nameB) {
            return lastNameB?.localeCompare(lastNameA);
          }
          return nameB?.localeCompare(nameA);
        }
      },
      csvFormatter: (_cellContent, row) => {
        const firstName = row?.lead_detail?.first_name || "--";
        const lastName = row?.lead_detail?.last_name || "--";
        if (firstName !== "--" && lastName !== "--") {
          return `${firstName} ${lastName}`;
        } else if (firstName !== "--") {
          return firstName;
        } else if (lastName !== "--") {
          return lastName;
        } else {
          return "--";
        }
      },
      columnName: 'call_name',
    },
    {
      dataField: 'lead_detail.phone',
      hidden: (hide_user_column_preference?.['call_phone'] === null) ? true : (hide_user_column_preference?.['call_phone']),
      text: 'Phone',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_detail.phone', true),
      formatter: phoneNumberFormatter,
      columnName: 'call_phone'
    },
    {
      dataField: 'call_duration',
      hidden: (hide_user_column_preference?.['call_duration'] === null) ? true : (hide_user_column_preference?.['call_duration']),
      text: 'Call Duration',
      headerFormatter: forColumnHeaderWrapper,
      splitHeader: true,
      sort: colSort('call_duration', true),
      sortFunc: backendSortingEnabled ? undefined : sortStringAsFloat,
      formatter: timeFormatter,
      csvFormatter: (_cellContent, row, rowIndex) => (timeFormatter(_cellContent || '0.0')),
      columnName: 'call_duration'
    },
    {
      dataField: 'price',
      hidden: (hide_user_column_preference?.['cost'] === null) ? true : (hide_user_column_preference?.['cost']),
      text: 'Cost',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('price', true),
      sortFunc: backendSortingEnabled ? undefined : sortStringAsFloat,
      formatter: costFormatter,
      csvFormatter: (cellContent, row, rowIndex) => (cellContent ? SfDollarStringFormatter(cellContent) : "--"),
      columnName: 'cost'
    },
    {
      dataField: 'refund_status',
      hidden: (hide_user_column_preference?.['call_refund_status'] === null) ? true : (hide_user_column_preference?.['call_refund_status']),
      text: 'Return',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('refund_status', true),
      formatter: (cell) => cell || '--',
      csvFormatter: (cell) => cell || '--',
      columnName: 'call_refund_status'
    },
    {
      dataField: 'lead_detail.insured',
      hidden: (hide_user_column_preference?.['call_insured'] === null) ? true : (hide_user_column_preference?.['call_insured']),
      text: 'Insured',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_detail.insured', true),
      formatter: yesNoFormatter,
      csvFormatter: yesNoFormatter,
      columnName: 'call_insured'
    },
    {
      dataField: 'lead_detail.address',
      hidden: (hide_user_column_preference?.['call_address'] === null) ? true : (hide_user_column_preference?.['call_address']),
      text: 'Address',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_detail.address', true),
      formatter: defaultFormatter,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent || "--"),
      columnName: 'call_address'
    },
    {
      dataField: 'lead_detail.city',
      hidden: (hide_user_column_preference?.['call_city'] === null) ? true : (hide_user_column_preference?.['call_city']),
      text: 'City',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_detail.city', true),
      formatter: defaultFormatter,
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent || "--"),
      columnName: 'call_city'
    }, {
      dataField: 'lead_detail.state',
      hidden: (hide_user_column_preference?.['call_state'] === null) ? true : (hide_user_column_preference?.['call_state']),
      text: 'State',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_detail.state', true),
      columnName: 'call_state'
    }, {
      dataField: 'lead_detail.num_employees',
      hidden: nullHandlerCustomizeColumns(hide_user_column_preference?.['call_num_employees']),
      text: 'Number of Employees',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_detail.num_employees', true),
      formatter: (cellContent, row) => {
        const numEmployees = cellContent || row?.lead_business_entities?.[0]?.num_full_time_employees;
        return defaultFormatter(numEmployees);
      },
      csvFormatter: (cellContent, row) => {
        const numEmployees = cellContent || row?.lead_business_entities?.[0]?.num_full_time_employees;
        return numEmployees || "--";
      },
      columnName: 'call_num_employees'
    }, {
      dataField: 'lead_detail.zip',
      hidden: (hide_user_column_preference?.['call_zip_code'] === null) ? true : (hide_user_column_preference?.['call_zip_code']),
      text: 'Zip Code',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_detail.zip', true),
      csvFormatter: (_cellContent, row, rowIndex) => (_cellContent || "--"),
      columnName: 'call_zip_code'
    },
    {
      dataField: 'campaign.name',
      hidden: (hide_user_column_preference?.['call_campaign_name'] === null) ? true : (hide_user_column_preference?.['call_campaign_name']),
      text: 'Campaign Name',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('campaign.name', true),
      formatter: (cellContent, row, rowIndex) => {
        return (
          <ToggleableLink className="text-sfblue" to={`/campaigns/${row.campaign_id}/summary`} disabled={!!row?.campaign?.discarded_at}>
            {nameWithDeletedFormatter(cellContent, row?.campaign, rowIndex, 'discarded_at')}
          </ToggleableLink>
        )
      },
      columnName: 'call_campaign_name'
    },
    {
      dataField: 'ad_group_name',
      hidden: (hide_user_column_preference?.['profile'] === null) ? true : (hide_user_column_preference?.['profile']),
      text: 'Profile',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('ad_group_name', true),
      formatter: (cellContent, row) => (cellContent ? cellContent : "--"),
      columnName: 'profile',
      csvFormatter: (cellContent, row, rowIndex) => (cellContent || "--"),
    },
    {
      dataField: 'lead_type_id',
      hidden: (hide_user_column_preference?.['call_lead_type'] === null) ? true : (hide_user_column_preference?.['call_lead_type']),
      text: 'Type',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('lead_type_id', true),
      formatter: (cellContent) => capitalizeWord(getLeadTypeById(cellContent)?.name || ''),
      csvFormatter: (cellContent, row, rowIndex) => (cellContent ? capitalizeWord(getLeadTypeById(cellContent)?.name || "") : ""),
      columnName: 'call_lead_type'
    },
    {
      dataField: 'transfer_type',
      hidden: (hide_user_column_preference?.['transfer_type'] === null) ? true : (hide_user_column_preference?.['transfer_type']),
      text: 'Transfer Type',
      sort: colSort('transfer_type', true),
      hasInfoTooltip: true,
      tooltipDescription: 'Refers to the type of Incoming phone call. It can be warm, cold, blind or any.',
      headerFormatter: forColumnHeaderWrapper,
      splitHeader: true,
      formatter: (cellContent, row, rowIndex) => (cellContent ? (<span className="text-capitalize">{cellContent}</span>) : "--"),
      csvFormatter: (cellContent, row, rowIndex) => (cellContent ? cellContent : "--"),
      columnName: 'transfer_type'
    },
    {
      dataField: 'disposition',
      hidden: (hide_user_column_preference?.['call_status'] === null) ? true : (hide_user_column_preference?.['call_status']),
      text: 'Disposition',
      sort: colSort('disposition', true),
      columnName: 'call_status',
      hasInfoTooltip: true,
      tooltipDescription: 'Allows you to categorize the call based on where you are in the sales process with the prospect.',
      headerFormatter: forColumnHeaderWrapper,
      events: {
        onKeyDown: (e, row, rowIndex) => {
          if (e.code == 'Enter') {
            setLoadingRowIndex(rowIndex);
            onClickSaveDisposition(row, nameInput)
          }
        },
        onClick: (e, _column, _columnIndex, row, rowIndex) => {
          if (!row?.lead_id) return

          setLoadingCell({ row: rowIndex, column: TABLE_COLMN_NAMES.STATUS });
          setLoadingRowIndex(rowIndex);
          if (e.target.name === 'saveName') {
            onClickSaveDisposition(row, nameInput)
          } else if (e.target.name === 'resetName') {
            setIsEditingStatus(null);
          } else {
            if (isEditingStatus?.row != rowIndex) {
              setSelectedStatus(getOptionFromValueForSelectBox(CALLS_STATUS_OPTIONS, row?.disposition) || CALLS_STATUS_OPTIONS[0]);
            }
            setIsEditingStatus({ row: rowIndex });
          }
        }
      },
      formatter: (cellContent, row, rowIndex) => {
        return (
          <div className={`d-flex ${DISPOSITION_EDITOR_CLASS}`}>
            <UncontrolledDropdown
              isOpen={((isEditingStatus != null) && (isEditingStatus.row == rowIndex))}>
              <DropdownToggle href="#" className='card-drop fsnormal' tag="i">
                {
                  (loading === true)
                    && (loadingCell.row === rowIndex)
                    && (loadingCell.col === TABLE_COLMN_NAMES.STATUS) ? (<ModifyLoadingIcon color="secondary" />) : (
                    <>
                      <span className='text-black'>{row?.disposition || CALLS_STATUS_OPTIONS[0]?.value}</span>
                      {
                        row?.lead_id ? (
                          <span className={`ms-1 font-size-16 ${(rowIndex === editIconRow) ? '' : 'edit-hover-class'}`}>
                            <a><i className="mdi mdi-pencil text-success" /></a>
                          </span>
                        ) : null
                      }
                    </>
                  )
                }
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-start">
                <DropdownItem className="font-weight-semibold">Disposition</DropdownItem>
                <DropdownItem divider />
                <DropdownItem text style={{ width: '365px' }}>
                  <div className="d-flex flex-column">
                    <div className="form-group">
                      <Select
                        name="call_status"
                        onChange={(e) => {
                          setSelectedStatus(e);
                        }}
                        value={selectedStatus}
                        options={CALLS_STATUS_OPTIONS}
                        classNamePrefix="select2-selection sf_dropdown_popup"
                        placeholder=""
                        // Render the option list in a <body> portal so it draws over the card
                        // instead of being clipped by the table's 50vh scroll container.
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      />
                    </div>
                    <div className="ms-auto mt-2">
                      <button className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`} name="saveName" type="submit">Save</button>
                      <button className="btn btn-sm btn-light mx-1" name="resetName" type="reset">Cancel</button>
                    </div>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        )
      }
    }, {
      dataField: 'created_at',
      hidden: (hide_user_column_preference?.['call_received'] === null) ? true : (hide_user_column_preference?.['call_received']),
      text: 'Received',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('created_at', true),
      formatter: dateCreatedFormatter,
      csvFormatter: (cellContent) => (cellContent ? format(utcToZonedTime(cellContent, getIANATimezoneStringForAbbreviation(REPORTING_TIMEZONE)), 'MM/dd/yyyy hh:mm aa') : '--'),
      filter: textFilter({
        style: {
          display: 'none',
        },
        getFilter: (filter) => {
          dateFilter = filter;
        },
        onFilter: onFilterByDateFunc,
      }),
      columnName: 'call_received'
    }, {
      dataField: 'recording_url',
      hidden: (hide_user_column_preference?.['call_recording'] === null) ? true : (hide_user_column_preference?.['call_recording']),
      text: 'Call Recording',
      headerFormatter: forColumnHeaderWrapper,
      formatter: (cellContent, row) => {
        const isPlaying = currentPlayer === row.id;
        return (
          <ReactAudioPlayer
            id={row.id}
            src={cellContent}
            style={{ height: '24px' }}
            controls={true}
            onPlay={(e) => { handleAudioPlayerClick(e, row); currentPlayerRef.current = e.target; }} // pass the audio element reference to the handler function
            onPause={() => { }}
            isPlaying={isPlaying}
          />)
      },
      csvFormatter: (cellContent, row) => (row.recording_link || 'No recording available'),
      columnName: 'call_recording'
    }, {
      dataField: 'drivers',
      hidden: (hide_user_column_preference?.['call_drivers'] === null) ? true : (hide_user_column_preference?.['call_drivers']),
      text: 'Applicants',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('drivers', true),
      formatter: (cellContent, _row) => (cellContent || 0),
      csvFormatter: (cellContent, _row) => (cellContent || 0),
      columnName: 'call_drivers'
    }, {
      dataField: 'vehicles',
      hidden: (hide_user_column_preference?.['call_vehicles'] === null) ? true : (hide_user_column_preference?.['call_vehicles']),
      text: 'Vehicles',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('vehicles', true),
      formatter: (cellContent, _row) => (cellContent || '--'),
      csvFormatter: (cellContent, _row) => (cellContent || '--'),
      columnName: 'call_vehicles'
    },
    {
      dataField: 'aid',
      hidden: !bsh_isAdminUserDetailsPresent() || (hide_user_column_preference?.['aid'] === null) ? true : (hide_user_column_preference?.['aid']),
      text: 'AID',
      sort: colSort('aid', true),
      csvExport: bsh_isAdminUserDetailsPresent(),
      hasAdminTooltip: true,
      headerFormatter: forColumnHeaderWrapper,
      formatter: (cellContent, _row) => (cellContent || '--'),
      csvFormatter: (cellContent, _row) => (cellContent || 0),
      columnName: bsh_isAdminUserDetailsPresent() ? 'aid' : ''
    },
    {
      dataField: 'cid',
      hidden: !bsh_isAdminUserDetailsPresent() || (hide_user_column_preference?.['cid'] === null) ? true : (hide_user_column_preference?.['cid']),
      text: 'CID',
      sort: colSort('cid', true),
      csvExport: bsh_isAdminUserDetailsPresent(),
      hasAdminTooltip: true,
      headerFormatter: forColumnHeaderWrapper,
      formatter: (cellContent, _row) => (cellContent || '--'),
      csvFormatter: (cellContent, _row) => (cellContent || 0),
      columnName: bsh_isAdminUserDetailsPresent() ? 'cid' : ''
    },
    {
      dataField: 'campaign.brand.name',
      hidden: (hide_user_column_preference?.['brand'] === null || !show_rtb_brand_ui_changes) ? true : (hide_user_column_preference?.['brand']),
      text: 'Brand',
      headerFormatter: forColumnHeaderWrapper,
      sort: colSort('campaign.brand.name', true),
      formatter: defaultFormatter,
      columnName: 'brand'
    },
    ...(isBenepathBrand && showLeadAndCallsNotes ? [{
      dataField: 'call_notes',
      text: 'Notes',
      headerFormatter: forColumnHeaderWrapper,
      sort: false,
      hasInfoTooltip: true,
      tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.LEAD_AND_CALL_NOTES,
      formatter: notesFormatter,
      formatExtraData: call_notes_loading,
      csvExport: false,
      hidden: (hide_user_column_preference?.['call_notes'] === null) ? true : (hide_user_column_preference?.['call_notes']),
      columnName: 'call_notes'
    }] : []),
    ...(generateSICColumns('call', hide_user_column_preference))

  ];
  const rowEvents = {
    onMouseEnter: (_e, _column, rowIndex) => {
      setEditIconRow(rowIndex);
    },
    onMouseLeave: (_e, _column, _rowIndex) => {
      setEditIconRow(null);
    },

  };

  const handleAnalyticsDataExport = (e) => {
    e.preventDefault();

    const exportFilters = getCallsExportFilters();
    const newUrl = getNewUrl({ page_number: 1 }, REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_URL_FILTERS_ON_CALLS)
    if (newUrl != "") {
      const parsedFilters = getParsedFilters(urlQueryParams)
      parsedFilters.brand_id = updatedBrandId()
      if (exportFilters) {
        const filterModalData = convertStringifiedNullToNull(exportFilters);
        parsedFilters.filters = JSON.stringify(filterModalData || {});
      }
      if (backendSortingEnabled) {
        parsedFilters.sort_column = CALLS_BACKEND_SORTABLE_COLUMNS.includes(sortState.column)
          ? sortState.column : DEFAULT_SORT_COLUMN;
        parsedFilters.sort_direction = sortState.direction || DEFAULT_SORT_DIRECTION;
      }
      dispatch(exportCallsOnEmail({ queryParams: parsedFilters }, true))
    }
    else {
      const exportParams = buildCallsListQueryParams(1, exportFilters);
      dispatch(exportCallsOnEmail({ queryParams: exportParams }, true))
    }
  }


  // react-select opens its menu on mousedown, and when the menu does not fit below the control
  // it animate-scrolls the page to bring the menu into view. The mouseup then lands on a
  // different element, so the browser dispatches the click on a common ancestor well outside
  // the disposition cell. Remembering where the press started keeps that scroll from reading as
  // an outside click, which used to close the editor the instant it was opened on short windows.
  const rememberDropdownPressTarget = (e) => {
    dropdownPressTargetRef.current = e.target;
  };

  //For disabling dropdown on clicking outside
  const closeDropdown = (e) => {
    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ALLOW_DROPDOWN_CLOSE)) {
      return
    }

    const pressTarget = dropdownPressTargetRef.current || e.target;
    dropdownPressTargetRef.current = null;

    // Presses inside the editor (toggle, react-select menu, Save/Cancel) are handled by the
    // disposition column's own click handler.
    if (pressTarget?.closest?.(DISPOSITION_EDITOR_SELECTOR)) {
      return
    }

    setIsEditingStatus(null);
  };

  useEffect(() => {
    if (checkUrlFiltersPresent(urlQueryParams)) {
      const parsedFilters = getParsedFilters(urlQueryParams)
      parsedFilters.brand_id = updatedBrandId()
      setFilterModal({ ...filterModal, ...JSON.parse(parsedFilters?.filters || '{}') })
      !loading && dispatch(getCalls({
        queryParams: parsedFilters,
        replaceResults: shouldUseOffsetPagination,
        useCache: shouldUseOffsetPagination,
      }, true));
    }
    // Run only on initial mount so URL hydration happens once.
    // Including urlQueryParams causes re-runs when history/location changes and triggers duplicate fetches.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const sortedColumns = useMemo(() => {
    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CALLS_PAGE)) {
      return callsColumn
    }
    else {
      return sortColumnsByOrder(callsColumn, customizeColumnsOrder);
    }
  }, [filteredCalls, callsColumn, customizeColumnsOrder, customizeColumnsModal])
  return (
    <>
      {/* Action Modals */}
      {isBenepathBrand && (
        <LeadNoteModal
          modalState={callNoteModal}
          onSubmitClick={onSubmitCallNoteModal}
          onCloseClick={onCloseCallNoteModal}
          textHeading="Call Notes"
        />
      )}
      <CustomizeColumnsModal
        pageName={PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.CALLS}
        setModalState={setCustomizeColumnsModal}
        modalState={customizeColumnsModal}
        onSubmitModalState={onSubmitCustomizeColumnsModal}
        handleColumns={handleColumns}
        onClickModalClose={onCloseCustomizeColumnsModal}
        dragndropFeatureFlag={REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CALLS_PAGE}
      />
      <CallFilterModal
        isActive={isActiveFilterModal}
        modalState={filterModal}
        currentAccountTimeZone={REPORTING_TIMEZONE}
        onSubmitModalState={onSubmitOpenFilterModal}
        onClickModalClose={onCloseFilterModal}
        campaignOptions={campaignOptions}
        brandList={brandList}
        show_rtb_brand_ui_changes={show_rtb_brand_ui_changes}
      />
      <div onMouseDownCapture={rememberDropdownPressTarget} onClick={closeDropdown} className="page-content" id="page-content-wrapper">
        <MetaTags>
          <title>Calls | {AppConfiguration.WEBSITE}</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between">
            <Breadcrumbs breadcrumbItem="Calls" copyUrl={true} />
            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE) ? (<div className="float-end">
              <button className="d-flex align-items-center text-sfblue bg-transparent rounded border-0" type="button" onClick={onClickOpenCustomizeColumnsModal} >
                <i className="bx bx-columns font-size-18 me-2 bx-sm" />
                Customize Columns
              </button>
            </div>) : null}
          </div>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <ToolkitProvider
                    keyField="id"
                    // If we hardcode any of the field's hidden value then only customize columns works
                    columns={[{ dataField: 'dummy', hidden: true, csvExport: false }, ...sortedColumns]}
                    data={filteredCalls.map((call) => {
                      const refund_status = getLeadRedundStatus(call?.refund_status, call?.refund_created_at)
                      return {
                        ...call,
                        refund_status: refund_status ? capitalizeFirstLetter(refund_status.toLowerCase()) : null
                      }
                    })}
                    search
                    exportCSV={{
                      fileName: "Calls.csv",
                      exportAll: false,
                    }}
                  >
                    {toolkitProps => (
                      <>
                        {(() => {
                          const offsetLookAheadPages = 8
                          const currentPage = Math.max(1, Number(last_page_fetched) || 1)
                          const knownTotalPages = Math.max(Number(total_number_of_pages) || 0, currentPage)
                          const paginationTotal = knownTotalPages > 0
                            ? knownTotalPages
                            : (has_next_page
                              ? currentPage + (has_lookahead_pages ? offsetLookAheadPages : 1)
                              : currentPage)
                          return (
                            <>
                        <Row className="">
                          <Col md="auto" className="align-self-end">
                            <FormGroup className="mt-1 mb-0">
                              <div>
                                <button
                                  className={`d-flex align-items-center btn btn-outline-primary ${(filterModal?.isActiveModal || filterCheckedCount !== 0) ? 'filter-btn' : ''} ${filterCount === 0 ? 'filter-btn-w' : ''}`}
                                  type='button'
                                  onClick={onClickOpenFilterModal}
                                >
                                  <i className="bx bx-filter font-size-18 align-middle me-2" />
                                  Filters {filterCount != 0 && <span className={filterModal?.isActiveModal ?
                                    'numberCircle' : 'numberCircle border-0'}> {filterCount} </span>}
                                </button>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="2" className="d-none">
                            <FormGroup>
                              <Label className="font-weight-semibold">
                                Type
                              </Label>
                              <div>
                                <Select
                                  value={selectedLeadGroup}
                                  onChange={handleLeadType}
                                  options={optionGroupTypeForCalls}
                                  classNamePrefix="select2-selection"
                                />
                              </div>
                            </FormGroup>
                          </Col>
                          <Col md="2" className="align-self-end d-none">
                            <div>
                              <FormGroup>
                                <DateRangePicker
                                  ianaTz={getIANATimezoneStringForAbbreviation(current_account?.timezone)}
                                  value={selectedDateRange}
                                  options={Object.keys(DATE_RANGE_OPTIONS).map((opt) => createOption(
                                    DATE_RANGE_OPTIONS[opt],
                                    new Date(),
                                    getIANATimezoneStringForAbbreviation(current_account?.timezone),
                                  ))}
                                  onChange={(value) => {
                                    handleTimeAndDate(value);
                                  }}
                                />
                              </FormGroup>
                            </div>
                          </Col>
                          <Col md="2" className="align-self-end d-none">
                            <FormGroup className="mb-0">
                              <div className="search-box me-2 d-inline-block">
                                <div className="position-relative">
                                  <Input
                                    className="rounded"
                                    value={searchTerm}
                                    placeholder="Search"
                                    onChange={(e) => {
                                      setSearchTerm(e.target.value);
                                    }}
                                  />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col xl="auto" className="align-self-center">
                            <div className="d-flex flex-wrap align-items-center">
                              {filteredColumns && filteredColumns.map((single_object, idx) => (
                                <div key={idx} className={`mx-2 mb-1 ${UserStyle.selected_filter}`}>
                                  <div className="d-flex align-items-center">
                                    <span>{single_object?.name} : <b>{single_object?.value}</b></span>
                                    <a className={`ms-2 ${getPrimaryTextClass()} font-size-18`} onClick={() => onClickRemoveFilter(single_object?.fieldName)} style={{ cursor: "pointer" }}>
                                      <span aria-hidden="true">&times;</span>
                                    </a>
                                  </div>
                                </div>
                              ))
                              }
                            </div>
                          </Col>
                          <Col xl="auto" className="ms-auto align-self-end">
                            <div className="d-flex flex-row gap-2">

                              <div>
                                <FormGroup className="align-self-end">
                                  <div>
                                    <CustomExportCSVButton
                                      className="btn btn-outline-sfblue"
                                      applyCustomOnClick={true}
                                      onClick={handleAnalyticsDataExport}
                                      {...toolkitProps.csvProps}
                                    >
                                      <i className="bx bx-import font-size-14 align-middle me-2" />
                                      {export_email_loading ? "Please Wait..." : "Export"}
                                    </CustomExportCSVButton>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row id='calls-table' className="sfTable-Container table-responsive">
                          <Col xl="12">
                            {!filteredCalls?.length && (loading || user_column_preference_call_loading) ? (
                              <SfLoadingSkeleton rows={5} cols={8} />
                            ) : (
                              <BootstrapTable
                                keyField="id"
                                responsive
                                bordered={false}
                                striped={false}
                                rowEvents={rowEvents}
                                rowClasses="tr-hover"
                                filter={filterFactory()}
                                classes="table align-middle table-nowrap text-black"
                                headerClasses="sftableHeader thead-h50 text-black"
                                headerWrapperClasses="thead-light"
                                noDataIndication="You currently don't have any calls"
                                remote={backendSortingEnabled ? { pagination: false, filter: false, sort: true } : false}
                                onTableChange={handleTableChange}
                                sort={{
                                  sortCaret: customSortCaret,
                                  ...(backendSortingEnabled && { dataField: sortState.column, order: sortState.direction }),
                                }}
                                {...toolkitProps.baseProps}
                              />
                            )}
                          </Col>
                        </Row>
                        {shouldUseOffsetPagination ? (
                          <OffsetPagination
                            currentPage={currentPage}
                            totalPages={paginationTotal}
                            hasNextPage={has_next_page}
                            hasDeepOffsetPages={has_lookahead_pages}
                            offsetLookAheadPages={offsetLookAheadPages}
                            loading={loading}
                            onPageChange={(page) => fetchCallsPage(page, filterCheckedCount > 0 ? activeFilteredColumnsState : null)}
                            className="campaign-analysis-pagination mt-3 align-items-center justify-content-end"
                          />
                        ) : (
                          <Row>
                            {!loading && <Col xl='auto'>
                              {last_page_fetched} out of {total_number_of_pages} page(s)
                            </Col>}
                            <Col xl='auto' className='ms-auto'>
                              {last_page_fetched < total_number_of_pages && <button className='btn btn-outline-sfblue'
                                onClick={() => fetchCallsPage(last_page_fetched + 1, filterCheckedCount > 0 ? activeFilteredColumnsState : null)}>{loading ? 'Please wait...' : 'Load More'}</button>}
                            </Col>
                          </Row>
                        )}
                            </>
                          )
                        })()}
                      </>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Calls
